import React from 'react';

export default class PanelSection extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log('PanelSection - Props', this.props);
		return (
			<div className="PanelSection">
				<div className="section-title-container">
					<span className="section-title">{this.props.title}</span>
					{this.props.hideEditLink ? null : (
						<span
							className="section-link"
							style={{ cursor: 'pointer' }}
							onClick={
								this.props.onClickShowPopup && this.props.onClickShowPopup
							}
						>
							{I18n.t('panel.edit_link')}
						</span>
					)}
					{typeof this.props.onClickAdd !== 'function' ? null : (
						<span
							className="section-link"
							style={{ cursor: 'pointer' }}
							onClick={this.props.onClickAdd}
						>
							{I18n.t('panel.add_link')}
						</span>
					)}
				</div>
				{this.props.children}
			</div>
		);
	}
}
